import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

// Only bundle English (primary language) - others lazy loaded
import enCommon from './locales/en/common.json'
import enHome from './locales/en/home.json'
import enDashboard from './locales/en/dashboard.json'
import enToc from './locales/en/toc.json'
import enChangelog from './locales/en/changelog.json'
import enReaderMap from './locales/en/readerMap.json'

export const supportedLanguages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'zh', name: 'Chinese', nativeName: '中文' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語' },
] as const

export type LanguageCode = (typeof supportedLanguages)[number]['code']

// English bundled in JS, other languages fetched on demand
const resources = {
  en: {
    common: enCommon,
    home: enHome,
    dashboard: enDashboard,
    toc: enToc,
    changelog: enChangelog,
    readerMap: enReaderMap,
  },
}

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: supportedLanguages.map(lang => lang.code),
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'home', 'dashboard', 'toc', 'changelog', 'readerMap'],

    // Allow partial bundled languages (English bundled, others lazy loaded)
    partialBundledLanguages: true,

    // Lazy load non-English translations from public/locales/
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: true, // Enable Suspense for loading states
    },
  })

export default i18n
